import { Component, OnInit, Inject, ChangeDetectorRef, ElementRef, ViewChild } from '@angular/core';
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TokenStorageService } from '../../services/token-storage.service';
import { environment } from 'src/environments/environment';
import { UserDTO } from 'src/app/interfaces/user';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { createNote, NoteDTO } from 'src/app/interfaces/note';
import { firstValueFrom } from 'rxjs';
import { NoteService } from 'src/app/services/note.service';
import { Editor } from '@tiptap/core';
import StarterKit from '@tiptap/starter-kit';
import { Image as TipTapImage } from '@tiptap/extension-image';
import { TableRow } from '@tiptap/extension-table-row';
import { TableCell } from '@tiptap/extension-table-cell';
import { TableHeader } from '@tiptap/extension-table-header';
import { TextAlign } from '@tiptap/extension-text-align';
import { TextStyle } from '@tiptap/extension-text-style';
import { CustomDiv } from 'src/app/extensions/customDiv';
import { CustomParagraph } from 'src/app/extensions/CustomParagraph';
import { CommonModule } from '@angular/common';
import { TaskService } from 'src/app/services/task.service';
import { createTask, TaskDTO } from 'src/app/interfaces/task';
import { TaskComponent } from '../task/task.component';
import { CustomParagraphAttributes } from 'src/app/extensions/CustomParagraphAttributes';


@Component({
  selector: 'app-note',
  imports: [FormsModule, CKEditorModule, MatIconModule, MatToolbarModule, CommonModule,
    FormsModule, ReactiveFormsModule, MatInputModule, MatButtonModule],
  templateUrl: './note.component.html',
  styleUrl: './note.component.scss'
})
export class NoteComponent implements OnInit {

  @ViewChild('editorElement') set editorElement(element: ElementRef<HTMLDivElement>) {
    if (element && !this.editor) {
      this.initializeEditor(element.nativeElement);
    } else if (element && this.editor) {
      // Alleen setContent aanroepen als de data van BUITENAF verschilt van de huidige editor inhoud
      const currentHTML = this.editor.getHTML();
      const newContent = this.note?.stringText || '';

      if (currentHTML !== newContent) {
        this.editor.commands.setContent(newContent);
      }
    }
  }

  isLoggedIn: boolean;
  user: UserDTO;
  role: string;
  isOk: boolean;
  envClass = 'prod';
  note: NoteDTO;
  public editor!: Editor;


  constructor(private router: Router, private tokenStorageService: TokenStorageService, public dialogRef: MatDialogRef<NoteComponent>,
    private cdr: ChangeDetectorRef, @Inject(MAT_DIALOG_DATA) data, private taskService: TaskService,
    private matDialog: MatDialog, private noteService: NoteService) {
    if (data != null) {
      this.note = data;
    }

  }

  isAuthorized() {
    this.isLoggedIn = !!this.tokenStorageService.getToken();
    if (this.isLoggedIn) {
      this.user = this.tokenStorageService.getUser();
      this.role = this.user.role;
      this.isOk = true;
    } else {
      this.isOk = false;
    }
    if (!this.isOk) {
      this.router.navigate(['home']);
    }
  }

  ngAfterViewInit(): void {
    this.cdr.detectChanges();
  }

  ngOnInit(): void {
    this.envClass = `env-${environment.name}`;

    this.isAuthorized();
  }

  initializeEditor(element: HTMLElement) {
    this.editor = new Editor({
      element: element,
      extensions: [
        StarterKit.configure({
          heading: {
            HTMLAttributes: {
              style: null,
            },
          },
        }),
        TextStyle,
        CustomDiv,
        CustomParagraphAttributes,
        TipTapImage,
        TableRow,
        TableHeader,
        TableCell,
        TextAlign.configure({ types: ['heading', 'paragraph'] })
      ],
      content: this.note?.stringText || '',
      onUpdate: ({ editor }) => {
        if (this.note) {
          this.note.stringText = editor.getHTML();
          this.note.dirty = true;
        }
      },
      onBlur: () => {
        this.onBlurEditor();
      }
    });
    this.cdr.detectChanges();
  }


  save() {
    this.saveNote()
    this.dialogRef.close({ note: this.note });
  }

  onBlurEditor() {
    if (this.note) {
      this.note.dirty = true;
      this.saveNote();
    }
  }

  async saveNote() {
    if (this.note && this.note.dirty) {
      try {
        this.note.dirty = false;
        const data = await firstValueFrom(this.noteService.saveNote(this.note.id, createNote(this.note.calendarId, this.note.eventId, this.note.title, this.note.stringText, this.note.noteType, this.note.archived, this.note.recurring, this.note.participants, this.note.hiddenTag, this.note.deleted, this.note.parentNoteId, this.note.endDate, this.note.uuid, this.note.lastModifiedTime, this.note.version)));
      } catch (error) {
        this.note.dirty = true;
      }
    }
  }

  onHeadingChange(event: Event) {
    const value = (event.target as HTMLSelectElement).value;
    if (value === 'p') {
      this.editor.chain().focus().setParagraph().run();
    } else {
      const level = parseInt(value, 10) as 1 | 2 | 3;
      this.editor.chain().focus().toggleHeading({ level }).run();
    }
  }

  addImage() {
    const url = window.prompt('Afbeelding URL invoeren:');
    if (url) {
      this.editor.chain().focus().setImage({ src: url }).run();
    }
  }

  async addTask() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.id = "AddTaskFromNote";
    dialogConfig.panelClass = "squaredDialog";
    dialogConfig.height = "530px";
    const title = await this.generateTitleForNote();
    const text = this.getSelectedText();
    dialogConfig.data = createTask(this.note.calendarId, title, text, "Not started", new Date(), new Date(Date.now() + 7 * 24 * 60 * 60 * 1000), new Date(), "Normal", 0, this.note.id);
    dialogConfig.width = "750px";
    const modalDialog = this.matDialog.open(TaskComponent, dialogConfig);
    modalDialog.afterClosed().subscribe(data => {
      if (data && data.task) {
        var task = data.task;
        task.calendarId = this.note.calendarId;
        task.noteId = this.note.id;
        task.sequence = 0;
        this.saveTask(task);
      }
    });
  }

  async generateTitleForNote() {
    const data = await firstValueFrom(this.taskService.getNumberOfTasksForNote(this.note.id));
    if (data) {
      return "Task " + (Number(data) + 1) + ": " + this.note.title;
    } else {
      return "Task: " + this.note.title;
    }
  }

  getSelectedText(): string {
    if (!this.editor) return '';
    const { from, to } = this.editor.state.selection;
    return this.editor.state.doc.textBetween(from, to, ' ');
  }

  async saveTask(task: TaskDTO) {
    const data = await firstValueFrom(this.taskService.saveTask(task.id, createTask(task.calendarId, task.title, task.text, task.status, task.creationDate, task.dueDate, task.statusDate, task.priority, task.sequence, task.noteId)));
  }

}
